import React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import * as serviceWorker from "./utils/helpers/serviceWorker";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";

const container = document.getElementById("root");
const root = createRoot(container);

const renderApp = async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID,
    key: "dashboard-client"
  });
  const router = createBrowserRouter([
    {
      path: "*",
      element: <LDProvider>
        <App />
      </LDProvider>
    }
  ]);
  root.render(<RouterProvider router={router} />);
};

renderApp();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
